// extracted by mini-css-extract-plugin
export default {"socialIcon":"Social_socialIcon__WzbcI"};